export const CONTROL_FUEL_PACK = 'CONTROLE_CARBURANT';
export const STATIONS_PACK = 'STATIONS_RESEAU';
export const TRANSPORT_PACK = 'TRANSPORT_DISTRIBUTION';

// Ordered by how a litre actually moves: someone asks for fuel, it is issued
// to a machine, then it is analysed. Sites, engins and quotas are the
// reference data behind that flow, so they follow it rather than open the
// menu. This is the single source of the labels — Layout renders the same
// array, so a route cannot be named two different things depending on the
// pack the client bought.
export const CONTROL_FUEL_NAV_ITEMS = [
  { to: '/control-fuel', label: 'Accueil carburant', module: 'fuel_consumption' },
  { to: '/control-fuel/requests', label: 'Demandes', module: 'fuel_requests' },
  { to: '/control-fuel/issues', label: 'Sorties carburant', module: 'fuel_issues' },
  { to: '/control-fuel/history', label: 'Consommation', module: 'fuel_consumption' },
  { to: '/control-fuel/sites', label: 'Sites', module: 'sites' },
  { to: '/control-fuel/assets', label: 'Engins', module: 'assets' },
  { to: '/control-fuel/quotas', label: 'Quotas', module: 'fuel_quotas' },
];

export const isControlFuelPrimaryPack = (activePack) => activePack === CONTROL_FUEL_PACK;

export const visibleControlFuelItems = (hasModule) =>
  CONTROL_FUEL_NAV_ITEMS.filter((item) => hasModule(item.module));

export const firstControlFuelRoute = (hasModule) =>
  visibleControlFuelItems(hasModule)[0]?.to || '/profile';

// Menu du pack Stations (lot 030), dans l'ordre de la journée du gérant : son
// accueil (la journée de la station), le poste, les cuves, les clients, les
// prix, les rapports, les annexes, le réseau, la conformité, les réglages. Une seule liste, reprise par le
// menu du pack principal et par la section Stations du pack Transport.
export const STATION_NAV_ITEMS = [
  { to: '/stations', label: 'Accueil', module: 'stations' },
  { to: '/stations/poste', label: 'Poste du jour', module: 'shifts' },
  { to: '/stations/cuves', label: 'Cuves et réceptions', module: 'tanks' },
  { to: '/stations/clients', label: 'Clients et bons', module: 'station_credit' },
  { to: '/stations/prix', label: 'Prix', module: 'prices' },
  { to: '/stations/rapports', label: 'Rapports', module: 'station_daily_report' },
  { to: '/stations/annexes', label: 'Annexes', module: 'station_annexes' },
  { to: '/stations/reseau', label: 'Réseau', module: 'multi_station_dashboard' },
  { to: '/stations/conformite', label: 'Conformité', module: 'reports' },
  { to: '/stations/reglages', label: 'Réglages', module: 'stations' },
];

export const isStationsPrimaryPack = (activePack) => activePack === STATIONS_PACK;

/**
 * La société a-t-elle des stations à montrer ? Les modules station sont dans les
 * modules par défaut du pack Transport et distribution: pour ce pack, un module
 * ouvert ne prouve rien, seule une station exploitée (`own_stations`, donnée du
 * serveur) compte. Les autres packs qui ouvrent les stations (Stations réseau,
 * Pro, Entreprise) gardent leurs écrans pour pouvoir en créer une.
 */
export const societeAStations = ({ ownStations, activePack }) =>
  ownStations === true || activePack !== TRANSPORT_PACK;

export const visibleStationItems = (hasModule) =>
  STATION_NAV_ITEMS.filter((item) => hasModule(item.module));

export const firstStationRoute = (hasModule) =>
  visibleStationItems(hasModule)[0]?.to || '/profile';

// Menu « Lots attribués » (lot 057) : un transporteur partenaire vend à la
// société un lot de camions chargés. Une seule liste, reprise par la colonne de
// gauche et par la feuille « Plus » du téléphone. « Paiements » (lot 058) n'est
// proposé qu'à qui voit les montants (`argent: true`, voir `filterNavItemsByModule`).
export const LOTS_NAV_ITEMS = [
  { to: '/lots', label: 'Tableau de bord', module: 'lots' },
  { to: '/lots/liste', label: 'Lots', module: 'lots' },
  { to: '/lots/suivi', label: 'Suivi', module: 'lots' },
  { to: '/lots/retours', label: 'Retours', module: 'lots' },
  { to: '/lots/paiements', label: 'Paiements', module: 'lots', argent: true },
];

export const visibleLotsItems = (hasModule, canSeeMoney = false) =>
  LOTS_NAV_ITEMS.filter((item) => hasModule(item.module) && (!item.argent || canSeeMoney === true));
